import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { formatCurrencyIntl } from '../../lib/formatters';

export default class JobRibbon extends Component {
  static propTypes = {
    addJob: PropTypes.object,
    editJobTitle: PropTypes.func,
    app: PropTypes.object,
    currency: PropTypes.string,
    close: PropTypes.func,
    payRange: PropTypes.shape({
      marketBaseSalary25th: PropTypes.number,
      marketBaseSalary50th: PropTypes.number,
      marketBaseSalary75th: PropTypes.number
    })
  };

  constructor(props) {
    super(props);
  }

  buildPayRange() {
    const { app, payRange, currency, close } = this.props;
    const { reports } = this.props.addJob;

    let percentile25, percentile75;

    const intl = { useThousands: false, useHourly: false, display: 'symbol', currency: currency };

    if (payRange && payRange.marketBaseSalary25th && payRange.marketBaseSalary75th) {
      percentile25 = payRange.marketBaseSalary25th;
      percentile75 = payRange.marketBaseSalary75th;
    } else if (reports && reports.payReport && reports.payReport.reports && reports.payReport.reports.basePayReport) {
      // Fall back on the basepayreport if details does not include composite 50th
      percentile25 = reports.payReport.reports.basePayReport.percentile25;
      percentile75 = reports.payReport.reports.basePayReport.percentile75;
    }

    if (percentile25 && percentile75) {
      percentile25 = formatCurrencyIntl(percentile25, intl, app);
      percentile75 = formatCurrencyIntl(percentile75, intl, app);
    }

    return (
      <React.Fragment>
        {close && <div className="icon-cancel editJob--close" onClick={close} />}
        <p className="job-ribbon__subtitle job-ribbon__subtitle--pay-range">Market Range</p>
        <p className="job-ribbon__pay-range">
          {percentile25} - {percentile75}
        </p>
      </React.Fragment>
    );
  }

  render() {
    const { selectedJobTitle, jobCode, workLocation, jobDetails } = this.props.addJob;
    const hasJobTitle = selectedJobTitle.length > 0;
    const noJobCode = this.props.addJob.noJobCode || (jobDetails && jobDetails.noJobCode);
    const jobRibbonStatusClass = hasJobTitle ? '' : 'job-ribbon--no-title';
    const col1 = (
      <div className="job-ribbon__title-column">
        <p className="job-ribbon__subtitle job-ribbon__subtitle--job-heading">PayScale Job Title</p>
        <h2 className="job-ribbon__title">{hasJobTitle ? selectedJobTitle : 'PayScale Job Title'}</h2>
        <div className="job-ribbon__details">
          <div className="job-ribbon__job-code">
            <span className="job-ribbon__detail-type job-ribbon__detail-type--job-code">Job Code</span>
            <span className="job-ribbon__detail-value">{noJobCode ? 'NO JOB CODE' : jobCode}</span>
          </div>
          <div className="job-ribbon__location">
            <span className="job-ribbon__detail-type job-ribbon__detail-type--location">Location</span>
            <span className="job-ribbon__detail-value">{workLocation}</span>
          </div>
        </div>
      </div>
    );

    const col2 = <div className="job-ribbon__pay-column">{this.buildPayRange()}</div>;

    return (
      <div className={`job-ribbon ${jobRibbonStatusClass}`}>
        {col1}
        {col2}
      </div>
    );
  }
}
